import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobReorderComponent } from './job-reorder.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    JobReorderComponent
  ],
  imports: [
    SharedModule,
    CommonModule
  ],
  exports: [
    JobReorderComponent
  ]
})
export class JobReorderModule { }
